import { CompanyInfo, PatnersInfo } from "../components/Generic";
import { About, Hero, Patners, Products, SSC } from "../components/Home";
import { Footer, Header } from "../components/Layouts";

function Home() {
  return (
    <>
      <div>
        <Header home={true} />
        <br />
        <br />
        <br />
        <Hero />
        <About />
        <Products />
        <SSC />
        <Patners />
        <CompanyInfo />
        <Footer />
      </div>
    </>
  );
}

export default Home;
